"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var defaults = {
  fieldType: null,
  type: null,
  options: [],
  isCustom: true,
  name: '',
  label: '',
  isRequired: true,
  numberDisplayHint: null
};

var FormField = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(FormField, _Record);

  function FormField() {
    (0, _classCallCheck2.default)(this, FormField);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FormField).apply(this, arguments));
  }

  (0, _createClass2.default)(FormField, null, [{
    key: "from",
    value: function from(json) {
      return new FormField(json);
    }
  }, {
    key: "add",
    value: function add(isCustom, name, label, numberDisplayHint) {
      return new FormField({
        isCustom: isCustom,
        name: name,
        label: label,
        numberDisplayHint: numberDisplayHint
      });
    }
  }]);
  return FormField;
}((0, _immutable.Record)(defaults));

exports.default = FormField;
module.exports = exports.default;